import CircuitBreakerAdmin from '../components/CircuitBreakerAdmin';

function CircuitBreakerTestPage() {
  return <CircuitBreakerAdmin />;
}

export default CircuitBreakerTestPage;
